// extracted by mini-css-extract-plugin
module.exports = {"modalDescription":"ConfirmShareProposalModal-module__modalDescription--1HDvY","modalButtons":"ConfirmShareProposalModal-module__modalButtons--2L-BE"};